// extracted by mini-css-extract-plugin
module.exports = {"inline-checkbox":"CheckboxGroup_inline-checkbox__3sdHA"};